import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import CancelSettelmentModal from "../../components/modals/CancelSettelmentModal";
import SettelmentConfirmModal from "../../components/modals/SettelmentConfirmModal";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { GetEnumsResponse } from "../../models/enum.model";
import { PaginationInfo } from "../../models/security.model";
import {
  FinalConfirmationRequest,
  GetSettlementRequestsResponse,
  SettlementListFilter,
} from "../../models/settlement.model";
import { getEnumsPersian } from "../../services/enum.services";
import {
  deleteSettlementRequest,
  finalConfirmation,
  GetPaymentSettlementZipFile,
  getSettlementRequests,
  getSettlementRequestsReportExcel,
} from "../../services/settlement.service";
import SettelmentWithSuppliersTable from "./components/SettelmentWithSuppliersTable";

const SettelmentWithStoresList = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [settelmentAmuont, setSettelmentAmount] = useState(0);
  const [settlementTypes, setSettlementTypes] = useState<GetEnumsResponse[]>();
  const [filterObject, setFilterObject] = useState<SettlementListFilter>();
  const [requestKey, setRequestKey] = useState<string>("");
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [settlementRequestsList, setSettlementRequestsList] = useState<
    GetSettlementRequestsResponse[]
  >([]);
  const history = useHistory<{
    settlementData?: {
      saleKey?: string;
      key: string;
      branchId?: number;
      customerPersonId?: number;
    };
  }>();
  const queryClient = useQueryClient();
  const { mutate: GetSettlementRequestsMutate } = useMutation(
    getSettlementRequests,
    {
      onSuccess: (data: ApiResultModel<GetSettlementRequestsResponse[]>) => {
        if (data) {
          setSettlementRequestsList(data.data);
          let pageInfoModel = new PageInfoModel();
          pageInfoModel.pageNumber = -1;
          pageInfoModel.pageSize = 10;
          pageInfoModel.total = 0;
          setPageInfo(data.pageInfo !== null ? data.pageInfo : pageInfoModel);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: getEnumsPersianMutate } = useMutation(getEnumsPersian, {
    onSuccess: (data: GetEnumsResponse[]) => {
      if (data) {
        setSettlementTypes(data);
      }
    },
    onError: () => {},
  });
  const { mutate: FinalConfirmationMutate } = useMutation(finalConfirmation, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenModal(false);
        history.push({
          pathname: "/settlementHistoryDetail",
          state: { settlementData: { key: requestKey } },
        });
        localStorage.setItem(
          "SETTLEMENT_REQUEST_DATA",
          JSON.stringify({ key: requestKey })
        );
      }
    },
    onError: () => {},
  });
  const { mutate: DeleteSettlementRequestMutate } = useMutation(
    deleteSettlementRequest,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setOpenCancelModal(false);
          GetSettlementRequestsMutate({
            paginationInfo: { pageNumber: 1, pageSize: 10 },
            filter: {},
          });
        }
      },
      onError: () => {},
    }
  );
  const { mutate: getSettlementRequestsReportExcelMutate } = useMutation(
    getSettlementRequestsReportExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetPaymentSettlementZipFileMutate } = useMutation(
    GetPaymentSettlementZipFile,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );

  const handleDownload = (key: string) => {
    GetPaymentSettlementZipFileMutate({ key });
  };
  const handleCheck = (amount: number, key: string) => {
    setRequestKey(key);
    setOpenModal(true);
    setSettelmentAmount(amount);
  };
  const handleDelete = (amount: number, key: string) => {
    setOpenCancelModal(true);
    setSettelmentAmount(amount);
    setRequestKey(key);
  };
  const handleRowAction = (key: string) => {
    history.push({
      pathname: "/StoreSettementRequestDetail",
      state: {
        settlementData: { key: key },
      },
    });
    localStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({ key: key })
    );
    // queryClient.setQueryData("SETTLEMENT_REQUEST_KEY", key);
  };

  const handleSubmitionModal = (values: FinalConfirmationRequest) => {
    FinalConfirmationMutate({ ...values, key: requestKey });
  };
  const handleCloseCancelModal = () => {
    setOpenCancelModal(false);
  };

  const handleSubmitCancalation = () => {
    DeleteSettlementRequestMutate({
      key: requestKey,
    });
  };
  const handleExportExcel = () => {
    getSettlementRequestsReportExcelMutate({
      ...filterObject,
    });
  };

  useEffect(() => {
    GetSettlementRequestsMutate({
      paginationInfo: currentPaginationInfo,
      filter: filterObject,
    });
  }, [filterObject, currentPaginationInfo]);

  useEffect(() => {
    getEnumsPersianMutate({
      enumNames: ["SettlementType"],
    });
  }, []);

  return (
    <div>
      <SettelmentWithSuppliersTable
        handleDownload={handleDownload}
        handleCheck={handleCheck}
        handleDelete={handleDelete}
        handleRowAction={handleRowAction}
        settlementRequestsList={settlementRequestsList}
        settlementTypes={settlementTypes!}
        setFilterObject={setFilterObject}
        pageInfo={pageInfo}
        currentPaginationInfo={currentPaginationInfo}
        setCurrentPaginationInfo={setCurrentPaginationInfo}
        handleExportExcel={handleExportExcel}
      />
      <SettelmentConfirmModal
        open={openModal}
        setOpen={setOpenModal}
        handleSubmition={handleSubmitionModal}
        amount={settelmentAmuont}
      />
      <CancelSettelmentModal
        open={openCancelModal}
        setOpen={setOpenCancelModal}
        handleCancel={handleSubmitCancalation}
        handleClose={handleCloseCancelModal}
        amount={settelmentAmuont}
      />
    </div>
  );
};

export default SettelmentWithStoresList;
